const headersDevice = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Производитель',
    value: 'manufacturer',
  },
  {
    text: 'Модель',
    value: 'model',
  },
  {
    text: 'ip-адрес',
    value: 'ip_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Последнее обновление',
    value: 'updatedAt',
  },
  {
    text: '',
    value: 'actions',
  },
];

const headersDevicesEdit = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'IP адрес',
    value: 'ip_address',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
  },
  {
    text: 'Модель устройства',
    value: 'model',
  },
  {
    text: 'Произвоитель устройства',
    value: 'manufacturer',
  },
];

const physicalStatus = [
  { id: 1, status: 'Установлен' },
  { id: 2, status: 'Не установлен' },
  { id: 3, status: 'Без интернет соединения' },
  { id: 4, status: 'Пусконаладка' },
  { id: 5, status: 'Старый домофон' },
];

const headersKeys = [
  {
    text: 'id',
    value: 'id',
  },
  {
    text: 'Название ключа',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Код ключа',
    value: 'code',
  },
  {
    text: 'Серийный номер',
    value: 'serial_number',
    sortable: false,
  },
  {
    text: 'Универсальный',
    value: 'universal',
  },
  {
    text: 'Комментарий',
    value: 'comment',
    sortable: false,
  },
  {
    text: '',
    value: 'actions',
    sortable: false,
  },
];

export { headersDevice, headersDevicesEdit, physicalStatus, headersKeys };
